var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#707070",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25 9.817V5.064c0-.94-.325-1.86-.914-2.592s-1.419-1.246-2.337-1.449C18.717.353 15.605.014 12.5.014c-3.105 0-6.217.34-9.25 1.009-.917.203-1.747.717-2.336 1.45C.324 3.203 0 4.124 0 5.062v4.754h3.434v4.168l-.17.114c-.872.58-1.392 1.553-1.392 2.6v3.013h21.256V16.7c0-1.047-.52-2.02-1.391-2.6l-.171-.114V9.817H25zM3.567 2.453C6.495 1.807 9.5 1.48 12.5 1.48c3 0 6.005.328 8.933.974 1.238.274 2.102 1.262 2.102 2.781h-4.053v-1.57H5.518v1.57H1.465c0-1.446.864-2.507 2.102-2.78zM1.465 8.352V6.699h4.051L3.863 8.352H1.465zm20.198 8.347v1.549H3.337v-1.549c0-.556.276-1.073.739-1.381l.823-.55v-5.38l2.083-2.084V5.13h11.036v2.175L20.1 9.388v5.381l.823.549c.463.308.74.825.74 1.381zm-.526-8.347l-1.653-1.653h4.051v1.653h-2.398z",
    transform: "translate(-140 -863) translate(140 804) translate(0 59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.05c-2.558 0-4.639 2.08-4.639 4.638s2.081 4.639 4.639 4.639c2.558 0 4.639-2.08 4.639-4.639 0-2.557-2.081-4.638-4.639-4.638zm0 7.812c-1.75 0-3.174-1.424-3.174-3.174S10.75 8.515 12.5 8.515s3.174 1.423 3.174 3.173-1.424 3.174-3.174 3.174z",
    transform: "translate(-140 -863) translate(140 804) translate(0 59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.768 10.956L13.232 10.956 13.232 12.421 11.768 12.421z",
    transform: "translate(-140 -863) translate(140 804) translate(0 59)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.bbacc9da21a4ecd5d8b1d4f0b6ae79e9.svg";
export { ForwardRef as ReactComponent };